import React from "react";
import { Constants } from "../../CommonMethhods/Constants";

function MTFDelayPaymentTable({ gridVal }) {
  const showMTFData = (gridVal) => {
    return (
      gridVal &&
      gridVal.map((item, key) => (
        <tr key={key}>
          <td>{item.dpcDate || "-"}</td>
          <td>{item.dpcBalanceCharges || "-"}</td>
          <td>{item.debitInt || "-"}</td>
          <td>{item.netDpcCharges || "-"}</td>
          <td>{item.fromDate || "-"}</td>
          <td>{item.toDate || "-"}</td>
        </tr>
      ))
    );
  };

  return (
    <div className="table-responsive scroll-table report-table-wrapper">
      <table className="table">
        <thead>
          <tr>
            <th scope="col">{Constants.Dpc_Date}</th>
            <th scope="col" className="text-center">
              {Constants.Dpc_Balance_Charges}
            </th>
            <th scope="col" className="text-center">
              {Constants.Debit_Int}
            </th>
            <th scope="col" className="text-center">
              {Constants.Net_Dpc_Charges}
            </th>
            <th scope="col" className="text-center">
              {"From Date"}
            </th>
            <th scope="col" className="text-center">
              {"To Date"}
            </th>
          </tr>
        </thead>
        <tbody>{showMTFData(gridVal)}</tbody>
      </table>
    </div>
  );
}

export default MTFDelayPaymentTable;
